"use strict"
exports.__esModule = true;
exports.BroomIconConfig = {
  name: 'BroomIcon',
  height: 512,
  width: 640,
  svgPath: 'M256.47 216.77l86.73 109.18s-16.6 102.36-76.57 150.12C206.66 523.85 0 510.19 0 510.19s3.8-23.14 11-55.43l94.62-112.17c3.97-4.7-.87-11.62-6.65-9.5l-60.4 22.09c14.44-41.66 32.72-80.04 54.6-97.47 59.97-47.76 163.3-40.94 163.3-40.94zM636.53 31.03l-19.86-25c-5.49-6.9-15.52-8.05-22.41-2.56l-232.48 177.8-34.14-42.97c-5.09-6.41-15.14-5.21-18.59 2.21l-25.33 54.55 86.73 109.18 58.8-12.45c8-1.69 11.42-11.2 6.34-17.6l-34.09-42.92 232.48-177.8c6.89-5.48 8.04-15.53 2.55-22.44z',
  yOffset: 0,
  xOffset: 0,
};
exports.BroomIcon = require('../createIcon').createIcon(exports.BroomIconConfig);
exports["default"] = exports.BroomIcon;